import { render, staticRenderFns } from "./HealthCoachingBookCoach.vue?vue&type=template&id=73779cd8"
import script from "./HealthCoachingBookCoach.vue?vue&type=script&lang=js"
export * from "./HealthCoachingBookCoach.vue?vue&type=script&lang=js"
import style0 from "./HealthCoachingBookCoach.vue?vue&type=style&index=0&id=73779cd8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports